import { FC } from "react";
import { Locale } from "../../../locales/Locale";
import { IdlocaGeneric } from "../../../locales/IdlocaGeneric";

interface IGetSelectedFiltersText {
    selectedMaker: number | null;
    selectedModel: number | null;
    selectedType: number | null;
    minMaxCC: number[];
    minMaxYear: number[];
    makers: { id: number; name: string }[];
    models: { id: number; name: string }[];
    types: { id: number; name: string }[];
}

export const GetSelectedFiltersText: FC<IGetSelectedFiltersText> = ({
    selectedMaker,
    selectedModel,
    selectedType,
    minMaxCC,
    minMaxYear,
    makers,
    models,
    types,
}) => {
    const filterComponents: JSX.Element[] = [];

    if (selectedMaker) {
        const makerName = makers.find(m => m.id === selectedMaker)?.name || "Unknown";
        filterComponents.push(
            <span key="maker" style={{ marginRight: "8px" }}>
                <Locale localeId={IdlocaGeneric.maker} /> {`: ${makerName}`}
            </span>
        );
    }
    if (selectedModel) {
        const modelName = models.find(m => m.id === selectedModel)?.name || "Unknown";
        filterComponents.push(
            <span key="model" style={{ marginRight: "8px" }}>
                <Locale localeId={IdlocaGeneric.model} /> {`: ${modelName}`}
            </span>
        );
    }
    if (selectedType) {
        const typeName = types.find(t => t.id === selectedType)?.name || "Unknown";
        filterComponents.push(
            <span key="type" style={{ marginRight: "8px" }}>
                <Locale localeId={IdlocaGeneric.type} /> {`: ${typeName}`}
            </span>
        );
    }
    if (minMaxCC) {
        filterComponents.push(
            <span key="cc" style={{ marginRight: "8px" }}>
                <Locale localeId={IdlocaGeneric.engine_size} /> {`: ${minMaxCC[0]} - ${minMaxCC[1]}`}
            </span>
        );
    }
    if (minMaxYear) {
        filterComponents.push(
            <span key="year" style={{ marginRight: "8px" }}>
                <Locale localeId={IdlocaGeneric.year} /> {`: ${minMaxYear[0]} - ${minMaxYear[1]}`}
            </span>
        );
    }

    if (filterComponents.length === 0) {
        return <Locale localeId={IdlocaGeneric.no_filters_applied} />;
    }

    return <>{filterComponents}</>;
};
